// extracted by mini-css-extract-plugin
export default {"durationsContainer":"styles_durationsContainer__DIlV1","durationButton":"styles_durationButton__j-2ZQ","selectedDurationButton":"styles_selectedDurationButton__cJL-1"};